import { useCallback } from 'react';
import { BreakpointSizesType } from '@pickit/pickit-grid-system';
import { Cell } from './styles';
import { TableCellProps } from './types';

const TableCell = <T,>({ children, header, cols, index }: TableCellProps<T>) => {
  const { col, align, type } = header;

  const getCols = useCallback(
    (breakpoint: BreakpointSizesType) => (typeof col === 'object' ? col[breakpoint] : col),
    [col],
  );

  return (
    <Cell
      data-testid={`${header.testId}-${index}`}
      align={align || 'left'}
      xxs={getCols('xxs')}
      xs={getCols('xs')}
      sm={getCols('sm')}
      md={getCols('md')}
      lg={getCols('lg')}
      xl={getCols('xl')}
      cols={cols}
      type={type}
    >
      {children}
    </Cell>
  );
};

export default TableCell;
